import { NavLink, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Me { tenantId: string; role: string }

export function AdminLayout() {
  const t = useT()
  // Hit /me to discover whether this tenant is internal. Server-side admin
  // routes will reject if not, so this is just a UI gate for friendly feedback.
  const me = useQuery({
    queryKey: ['admin-overview-gate'],
    queryFn: () => apiClient.get<unknown>('/admin/overview'),
    retry: false,
  })

  return (
    <div className="grid grid-cols-[200px_1fr] gap-6">
      <nav className="flex flex-col gap-1 text-sm">
        <h2 className="text-xs uppercase tracking-wide opacity-60 mb-2 px-2">{t('admin.nav.title')}</h2>
        <Item to="" label={t('admin.nav.overview')} end />
        <Item to="tenants" label={t('admin.nav.tenants')} />
        <Item to="users" label={t('admin.nav.users')} />
        <Item to="sites" label={t('admin.nav.sites')} />
        <Item to="runs" label={t('admin.nav.runs')} />
        <Item to="fixes" label={t('admin.nav.fixes')} />
        <Item to="ai-spend" label={t('admin.nav.aispend')} />
        <Item to="engines" label={t('admin.nav.engines')} />
        <Item to="rules" label={t('admin.nav.rules')} />
        <Item to="audit-log" label={t('admin.nav.audit')} />
        <Item to="platform-health" label={t('admin.nav.health')} />
      </nav>
      <div>
        {me.isError ? (
          <div className="p-6 rounded border" style={{ borderColor: 'var(--color-border)' }}>
            <h2 className="text-lg font-semibold mb-2">{t('admin.gate.title')}</h2>
            <p className="text-sm opacity-70">{t('admin.gate.body')}</p>
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  )
}

function Item({ to, label, end }: { to: string; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `px-2 py-1.5 rounded ${isActive ? 'bg-black/5 dark:bg-white/5 font-medium' : 'opacity-80 hover:opacity-100'}`
      }
    >
      {label}
    </NavLink>
  )
}
